/** Display placeholder when SKU is absent on a line item. */
export const MISSING_SKU_LABEL = '—';

/**
 * Resolve SKU for an order line item.
 * Contract (PR #72): items[].sku string | null on list + GET order/admin/:id.
 * Extra fields are fallbacks only when sku is missing.
 */
export const getOrderItemSku = (item = {}) => {
  if (item.sku !== undefined && item.sku !== null && String(item.sku).trim() !== '') {
    return String(item.sku).trim();
  }
  const candidates = [
    item.productSku,
    item.variantSku,
    item.product?.sku,
    item.variant?.sku,
    item.product?.variantSku,
  ];
  const found = candidates.find(
    (value) => value !== undefined && value !== null && String(value).trim() !== ''
  );
  return found != null ? String(found).trim() : null;
};

export const formatOrderItemSku = (item) => getOrderItemSku(item) || MISSING_SKU_LABEL;

/** Collect unique SKUs on an order for search / export. */
export const collectOrderSkus = (order) => {
  const items = order?.items || [];
  const set = new Set();
  items.forEach((item) => {
    const sku = getOrderItemSku(item);
    if (sku) set.add(sku.toLowerCase());
  });
  return Array.from(set);
};

/** True when query matches any line-item SKU on the order (client-side supplement). */
export const orderMatchesSkuQuery = (order, query) => {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  return collectOrderSkus(order).some((sku) => sku.includes(q));
};
